import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-data-view',
  imports: [],
  templateUrl: './seriennr.list-view.html',
  styleUrls: ['./seriennr.list-view.scss'],
})
export class SeriennrListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();

  constructor() {}
}
